<template>
  <p v-if="isTest" class="text-red">テスト版</p>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'is-test',
  computed: {
    ...mapState(['isTest'])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Organisms/isTest.vue